module.exports = __webpack_public_path__ + "img/Devops.009bbb96.svg";